import script from "./ProfileUser.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileUser.vue?vue&type=script&setup=true&lang=js"

import "./ProfileUser.vue?vue&type=style&index=0&id=66be167a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66be167a"]])

export default __exports__